<script setup>
const socials = [
  {
    name: 'Email',
    url: null,
    display: 'thisisbrax@gmail.com'
  },
  {
    name: 'LinkedIn',
    url: 'https://linkedin.com/in/braxtonfreeman1010',
    display: 'linkedin.com/in/braxtonfreeman1010'
  },
  {
    name: 'GitHub',
    url: 'https://github.com/bfreeman1010',
    display: 'github.com/bfreeman1010'
  }
]
</script>

<template>
  <div class="h-full w-full bg-white overflow-y-auto px-2 py-1 font-trebuchet-pixel text-md">
      <pre class="whitespace-pre-wrap font-trebuchet-pixel text-md">================================
CONTACT INFO
================================

Find me online at these links:

</pre>
      <div v-for="(social, index) in socials" :key="social.name" class="mb-2">
        <span class="text-black">{{ social.name }}:</span>
        <br />
        <a
          v-if="social.url"
          :href="social.url"
          target="_blank"
          rel="noopener noreferrer"
          class="text-blue-600 hover:text-blue-800 underline break-all"
        >{{ social.display }}</a>
        <span v-else class="break-all xp-colors">
          <span v-for="(char, i) in social.display" :key="i" :class="'xp-' + (i % 4)">{{ char }}</span>
        </span>
        <br />
      </div>
      <pre class="whitespace-pre-wrap mt-4 font-trebuchet-pixel text-md">
================================
Thanks for visiting!
================================</pre>
  </div>
</template>

<style scoped>
.xp-0 { color: #5AA02C; } /* Green */
.xp-1 { color: #0078D7; } /* Blue */
.xp-2 { color: #FFB900; } /* Yellow */
.xp-3 { color: #E81123; } /* Red */
</style>
